import React from 'react';
import { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import {orbitClusterTileList} from "../../actions/orbitClusterTileList";
import {ORBIT_CLUSTER} from "../../actions/types";
import {setOrbitCluster} from "../../actions/orbitCluster";
import {useDispatch} from "react-redux";
import {pageScrollPointReached} from "../../actions/pageScrollPointReached";

function ScrollTracker({
       children,
       threshold = 75,
       onThresholdReached,
       triggerOnce = true,
   }) {
    const [hasTriggered, setHasTriggered] = useState(false);
    const [scrollPercent, setScrollPercent] = useState(0);
    const location = useLocation();
    const dispatch = useDispatch();

    const handleTrigger = useCallback(async () => {
        if (triggerOnce && hasTriggered) return;

        if (/-\d+/.test(location.pathname)) {
            setHasTriggered(true);
            onThresholdReached?.();

            // Call API if endpoint provided
            try {
                const ca = await pageScrollPointReached({pageName: location.pathname}, (data) => {
                });
                await dispatch(ca);
            } catch (error) {
                console.error('API call failed:', error);
            }
        }
    }, [dispatch, hasTriggered, triggerOnce, onThresholdReached, location.pathname]);

    useEffect(() => {
        let ticking = false;

        const onScroll = () => {
            if (ticking) return;
            ticking = true;

            window.requestAnimationFrame(() => {
                const doc = document.documentElement;
                const scrollTop = doc.scrollTop || document.body.scrollTop || 0;
                const scrollHeight = doc.scrollHeight || document.body.scrollHeight || 0;
                const clientHeight = doc.clientHeight || window.innerHeight || 0;
                const maxScroll = scrollHeight - clientHeight;

                if (maxScroll <= 0) {
                    setScrollPercent(0);
                    ticking = false;
                    return;
                }

                const percent = Math.min(100, Math.max(0, (scrollTop / maxScroll) * 100));
                setScrollPercent(percent);

                if (scrollTop > 0 && percent >= threshold) {
                    handleTrigger();
                }

                ticking = false;
            });
        };

        window.addEventListener('scroll', onScroll, { passive: true });

        return () => window.removeEventListener('scroll', onScroll);
    }, [threshold, handleTrigger]);

    return (
        <div>
            {children}
        </div>
    );
}

export default ScrollTracker;
